import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UUID } from '@/types';
import { RootState } from '@/store';

type State = {
  dependantQueriesIds: UUID[];
  history: UUID[][];
};

const initialState: State = {
  dependantQueriesIds: [],
  history: [],
};

export const dependantQueriesSlice = createSlice({
  name: 'dependantQueries',
  initialState,
  reducers: {
    setDependantQueriesIds: (
      state,
      action: PayloadAction<State['dependantQueriesIds']>,
    ) => {
      if (state.dependantQueriesIds.length) {
        state.history.push(state.dependantQueriesIds);
      }
      state.dependantQueriesIds = action.payload;
    },
    goBack: (state) => {
      if (state.history.length) {
        state.dependantQueriesIds = state.history.pop()!;
      }
    },
  },
  extraReducers: {
    MODAL_HIDDEN: (state) => {
      state.dependantQueriesIds = [];
      state.history = [];
    },
  },
});

export const selectDependantQueriesIds = (state: RootState) =>
  state[dependantQueriesSlice.name].dependantQueriesIds;

export const selectDependantQueriesHistory = (state: RootState) =>
  state[dependantQueriesSlice.name].history;

export const { setDependantQueriesIds, goBack } = dependantQueriesSlice.actions;
